module.exports = __webpack_public_path__ + "static/img/wyfw1.b3e2d88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wyfw1.png
// module id = WG/B
// module chunks = 1